import { useMutation, useQuery } from "react-query"
import { Equimetres } from "../api/equimetres"
import { hydraTransform } from "../shared/utils/hydraTransformer"
import { TEquimetre } from "../shared/types/training.type"
import { CreateEqmSubscriptionDto } from "../dto/CreateEqmSubscriptionDto"

type MyEquimetresProps = {
    enableQuery: boolean,
    userId?: string,
    options?: string[]
}
export const useMyEquimetres = ({ enableQuery, userId, options }: MyEquimetresProps) => {


    const query = useQuery(['eqms'], () => Equimetres.getEquimetres(userId, options), {
        enabled: enableQuery
    })

    const updateEqmMutation = useMutation(({ id, data }: { id: number, data: Partial<TEquimetre> }) => Equimetres.updateEqm(id, data))


    const subscribeMutation = useMutation(({ data }: { data: CreateEqmSubscriptionDto }) => Equimetres.createSubscription(data.id, data.customer, data.payment_method_id))

    const resumeSubMutation = useMutation(({ id }: { id: number }) => Equimetres.resumeSubscription(id))
    const abortSubMutation = useMutation(({ id }: { id: number }) => Equimetres.abortSubscription(id))

    return {
        data: hydraTransform(query.data?.data ?? []),
        isLoading: query.isLoading || query.isFetching,
        updateEqm: updateEqmMutation,
        subscribeMutation,
        resumeSubMutation,
        abortSubMutation

    }
}